import { render, staticRenderFns } from "./Component-LeftPanel.vue?vue&type=template&id=2a3b97a2"
import script from "./Component-LeftPanel.vue?vue&type=script&lang=js"
export * from "./Component-LeftPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports